import { createFileRoute } from "@tanstack/react-router";
import { PortalMoneyPage } from "@/features/portalmoney/PortalMoneyPage";

export const Route = createFileRoute("/portal/money")({ component: PortalMoneyPage });
